var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceiptsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 509.36 509.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 254.68,
    y1: 1873.15,
    x2: 254.68,
    y2: 2384.02,
    gradientTransform: "translate(0 -1873.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0780af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d6183"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 509.36,
    height: 509.36,
    rx: 54.11,
    ry: 54.11,
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 282.5,
    width: 1.49,
    height: 0.99,
    style: {
      fill: "#0b7ba5"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,392.73l18.6,25.18c3.23,4.37,8.45,4.37,11.68,0l18.6-25.18c3.23-4.37,8.45-4.37,11.68,0l18.6,25.18c3.22,4.37,8.45,4.37,11.68,0l18.6-25.18c3.22-4.37,8.45-4.37,11.68,0l18.6,25.18c3.22,4.37,8.45,4.37,11.68,0l18.6-25.18c3.22-4.37,8.45-4.37,11.68,0l17.49,23.68c2.51,3.4,6.81.99,6.81-3.81V105.5c0-9.57-5.73-17.32-12.8-17.32h-216.41c-7.07,0-12.79,7.75-12.79,17.32v268.95s0,38.19,0,38.19c0,4.81,4.3,7.22,6.81,3.82l17.53-23.73c3.23-4.37,8.45-4.37,11.68,0ZM182.03,218.18h148.31c6.27,0,11.35-4.03,11.35-9s-5.08-9-11.35-9h-148.31c-6.27,0-11.35,4.03-11.35,9s5.08,9,11.35,9ZM330.33,176.18h-148.31c-6.27,0-11.35-4.03-11.35-9s5.08-9,11.35-9h148.31c6.27,0,11.35,4.03,11.35,9s-5.08,9-11.35,9ZM184.12,260.18h144.12c7.42,0,13.44-4.03,13.44-9s-6.02-9-13.44-9h-144.12c-7.42,0-13.44,4.03-13.44,9s6.02,9,13.44,9ZM332.09,302.18h-151.82c-5.3,0-9.59-4.03-9.59-9s4.29-9,9.59-9h151.82c5.3,0,9.59,4.03,9.59,9s-4.29,9-9.59,9Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptsIcon);
export default __webpack_public_path__ + "static/media/receipts-icon.c99f37c2fa37cc47c6d46553291c67c1.svg";
export { ForwardRef as ReactComponent };